module.exports = __webpack_public_path__ + "img/21.4d480d19.png";